import NotificationTopicSelector from './NotificationTopicSelector';

export default NotificationTopicSelector;
